import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './HowWeWork.css';

const HowWeWork: React.FC = () => {
  const steps = [
    {
      number: '01',
      title: 'Análisis',
      description: 'Entendemos tu idea, tu negocio y tus objetivos'
    },
    {
      number: '02',
      title: 'Diseño',
      description: 'Diseñamos una solución alineada a tu contexto operativo.'
    },
    {
      number: '03',
      title: 'Desarrollo',
      description: 'Contamos con foco en calidad y atención al detalle.'
    },
    {
      number: '04',
      title: 'Implementación',
      description: 'Integramos la solución en tu operación y capacitamos a tu equipo.'
    },
  ];

  return (
    <section className="how-we-work-section">
      <Container fluid="lg">
        <div className="section-header mb-5">
          <h2 className="section-title">¿CÓMO TRABAJAMOS?</h2>
        </div>
        <Row className="g-4">
          {steps.map((step, index) => (
            <Col key={index} xs={12} sm={6} lg={3}>
              <div className="step-card">
                <div className="step-number">{step.number}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default HowWeWork;
